// Product codes are data, including slashes, spaces, #, ?, + and percent signs.
export const getProductPath = (productCode) => `/product/${encodeURIComponent(productCode)}`;

export const getProductApiUrl = (apiBaseUrl, productCode, count = false) =>
  `${apiBaseUrl}/Products/by-code?productCode=${encodeURIComponent(productCode)}${count ? '&count=true' : ''}`;

// Decode the original segment exactly once. Router params can interpret the
// literal text "%2F" in a product code as another slash after decoding it.
export const getProductCodeFromPath = (pathname) => {
  const segment = pathname.split('/')[2] || '';
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
};
